export default {
    locale: "en",
    more: 'More',
    actions: 'Actions',
    edit: 'Edit',
    save: 'Save',
    remove: 'Delete',
    open: 'Open',
    showing: 'Show',
    of: 'of',
    from: 'From',
    to: 'To',
    toSmall: 'to',
    entries: 'Entries',
    entry: 'Entry',
    logout: 'Logout',
    yes: 'Yes',
    Okay: 'Take over',
    no: 'No',
    username: 'User',
    password: 'Password',
    login: 'Login',
    show: 'Show',
    zoom: 'Enlarge',
    searchPlaceholder: 'Search...',
    loadingPlaceholder: 'Load...',
    noItems: 'Unfortunately, no entries were found for your search query',
    search: 'Search',
    none: 'No ',
    help: 'Help',
    continue: 'Next',
    close: 'Close',
    download_file: 'Download ${title}',
    unknownError: 'An unknown error has occurred. Please try again and if this does not work, reload the whole page.',
    passwordPlaceholder: '******',
    columns: "Columns",
    filter: "Filter",
    reset_columns: "Reset Columns",
    reset_filters: "Reset Filters",
    modelTitle: '${title}',
    modelTitleWithContinue: 'Step 1: ${title}',
    calendar: "Calendar",
    calendarLocale: {
        resultsExceedsMaxPages: "Bitte verfeinern Sie Ihre Suche, um genaue Ergebnisse zu erhalten",
        buttonText: {
            prev: 'Prev',
            next: 'Next',
            today: 'Today',
            year: 'Year',
            month: 'Month',
            week: 'Week',
            day: 'Day',
            list: 'List',
        },
        weekText: 'W',
        allDayText: "All Day",
        noEventsText: 'No events to display',
        moreLinkText: "+ ${count} more"
    },
    loginPage: {
        welcomeTitle: 'Welcome to Websail',
        welcomeMessage: 'Please log in with your username and password in the upper right corner',
        loginErrorTitle: 'Error during login',
        noCredentials: 'Please enter your login details.'
    },

    errorPage: {
        title: 'Something went wrong...',
        sorry: 'We regret all inconveniences that occurred. If you have any questions, please feel free to contact us at ${supportNumber}.',
        hintTitle: 'How you might be able to fix the error',
        hint1: 'Go back one page',
        hint2: 'Reload the page',
        hint3: 'Restart your browser',
        hint4: 'Use Google Chrome',
    },

    notFoundPage: {
        title: 'The requested page was not found',
        message: 'The page you requested could not be found. Did you make a typing error?'
    },


    notAuthorizedPage: {
        title: 'You do not have access to this page',
        message: 'Please contact the system administrator for more information.'
    },

    errors: {
        options: 'The loading of the options failed. Please reload the page and try again.'
    },

    menu: {
        customers: 'Customers',
        customer: 'Customer',
        bookings: 'Bookings',
        booking: 'Booking',
        courses: 'Courses',
        exams: 'Exams',
        bills: 'Invoices',
        bill: 'Invoice',
        payments: 'Payments',
        payment: 'Payment',
        articleTypes: 'Article categories',
        articles: 'Articles',
        courseCategories: 'Course Categories',
        examCategories: 'Exam categories',
        employees: 'Employees',
        notifications: 'Email CC\'s',
        taxes: 'Tax rates',
        salutations: 'Salutations',
        options: 'Settings',
        partialExams: 'Exam topics',
        places: 'Addresses',
        prices: 'Included prices',
        documents: 'Document archive',
        templates: 'Document templates',
        content_blocks: 'Texts',
        help: 'Help',
        message_templates: 'Message templates',
        consents: 'Consent declarations',
        consent_user: 'Given consents',
        tags: 'Tags',
        tag_types: 'Tagging settings',
        banks: 'Bank accounts',
        bank_transactions: 'Bank transactions',
        exam_booking: 'Examinees',
        exam_booking_single: 'Exam Booking',
        files: 'File attachments',
        sepa_direct_debit_mandates: 'Direct debit mandates',
        aboutUs: "About VeranstaltungsButler",
        downloadOniOS: "Download Scanner on iOS",
        downloadOnAndroid: "Download Scanner on Android",
        loginOnMobile: "Mobile Login QR"
    },

    confirmNavigation: {
        title: 'Warning',
        message: 'Are you sure you want to discard your changes?',
        yes: 'Discard changes',
        no: 'Back'
    },

    confirmDelete: {
        title: 'Confirm deletion',
        message: 'Do you really want to delete ${itemTitle}?',
    },

    confirmAction: {
        title: '${actionTitle}',
        message: 'Do you really want to ${actionTitle} ${itemTitle}?',
        criticalConfirm: "Please enter \"${confirmText}\" to proceed.",
    },

    requiresSelection: {
        title: "Continue with all ${count} ${modelNamePlural}",
        message: "Do you want to continue all ${count} ${modelNamePlural}? You can also select individual entries on the left-hand side.",
    },

    time: {
        dateTimeFormat: 'ddd d.m H:MM',
        dateFormat: 'ddd d.m',
        timeFormat: 'H:MM',
        weekdaysShort: ['Su','Mo','Tu','We','Th','Fr','Sa'],
        weekdaysLetter: ['Su','Mo','Tu','We','Th','Fr','Sa'],
        months: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'],
        monthsShort: ['Jan','Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
        weekdays: [
            'Sunday',
            'Monday',
            'Tuesday',
            'Wednsday',
            'Thurday',
            'Friday',
            'Saturday'
        ],
    },

    page_navigation: {
        tooltip: 'Define the number of entries per page'
    },

    pagination: {
        tooltip: 'If more entries were found than are displayed per page, the current page can be changed here.'
    },

    table: {
        select_throughout_pages: "All ${count} items on this page selected.",
        select_throughout_pages_button_label: "Select all entries",
        clear_select_throughout_pages: "All entries selected.",
        clear_select_throughout_pages_button_label: "Clear selection",
        selectAll: "Select all",
        unselectAll: "Unselect all",
        selectRow: "Select row",
        unselectRow: "Unselect row",
        title_and_count: "${count} ${title}",
    },

    versions: {
        booking_form: "Booking form",
        admin: "VB Admin",
        backend: "API"
    },

    booking_form: {
        create_booking: "+ Booking",
        something_went_wrong: "An unknown error has occurred. Try to reload the page or contact customer support.",
    },

    mobile_login: {
        title: "Scan QR to login on the mobile application",
        description: "",
        image_loading_help_text: "Please wait while the QR is being loaded",
    },
    columns_configuration: {
        hideColumns: "Hide columns",
        hiddenColumnsCount: "${count} hidden columns",
    },
    filters: {
        no_filters_applied: "No filter conditions are applied.",
        add_filter: "Add Filter",
        select_filter: "Select Filter",
        filtered_by: "Filtered by ${filters}",
        filtered_by_more_1: "Filtered by ${0} and ${count} more",
        applied_filter_count: "${count} applied",
        where: "where",
        and: "and",
        range: {
            greater_than: "after ${value}",
            less_than: "before ${value}",
            between: "between ${min} - ${max}",
        },
        text: {
            contains: "contains",
        },
        number: {
            before: "before",
            after: "after",
            between: "between",
        },
        textarea: {
            contains: "contains",
        },
        wysiwyg: {
            contains: "contains",
        },
        bool: {
            includes: "includes",
        },
        belongs_to: {
            includes: "includes",
        },
        belongs_to_many: {
            allOf: "all of",
        },
        date: {
            today: "Today",
            tomorrow: "Tomorrow",
            yesterday: "Yesterday",
            thisweek: "this week",
            lastweek: "last week",
            nextweek: "next week",
            thismonth: "this month",
            lastmonth: "last month",
            nextmonth: "next month",
            before: "before",
            after: "after",
            between: "between",
        },
        datetime: {
            today: "Today",
            tomorrow: "Tomorrow",
            yesterday: "Yesterday",
            thisweek: "this week",
            lastweek: "last week",
            nextweek: "next week",
            thismonth: "this month",
            lastmonth: "last month",
            nextmonth: "next month",
            before: "before",
            after: "after",
            between: "between",
        },
        time: {
            today: "Today",
            tomorrow: "Tomorrow",
            yesterday: "Yesterday",
            thisweek: "this week",
            lastweek: "last week",
            nextweek: "next week",
            thismonth: "this month",
            lastmonth: "last month",
            nextmonth: "next month",
            before: "before",
            after: "after",
            between: "between",
        },
        file: {
            contains: "contains",
        },
        image: {
            contains: "contains",
        },
    },
    user: {
        profile: "Profile",
    },
    views: {
        renameView: "Rename",
        saveViewName: "Save",
        shareView: "Share",
        unshareView: "Unshare",
        sharedView: "Shared View",
        deleteView: "Delete",
        copyTitle: "${title} Copy",
        archivedViewTitle: "${title} (Archived)",
        duplicateCurrentView: "Duplicate Current View",
        save: "Save",
        saveAsOwn: "Duplicate View",
        confirmResetLastView: "${title} is the last available view. This view will be reset.",
    },
}